import * as React from 'react';

type RecentResearchHeaderProps = {
    title: string;
};

const RecentResearchHeader = (props: RecentResearchHeaderProps) => {
    const { title } = props;

    return (
        <div className="flex justify-start items-center px-10 py-5 w-full border-b">
            <div className="gap-2.5">
                <p className="font-semibold text-left uppercase text-dark">{title}</p>
            </div>
        </div>
    );
};

export default RecentResearchHeader;
